import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import { get_user_info } from '../../../helpers/api';
import StyledTab from '../../common/tabs/SimpleTab';
import SimpleTabs from '../../common/tabs/SimpleTabs';
import { a11yProps } from '../../../helpers/utils';
import TabPanel from '../../common/tabs/SimpleTabPanel';
import Loader from '../../common/Loader';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import SwipeableViews from 'react-swipeable-views';
import Eof from '../../common/Eof';
import useDesktopDisplay from '../../../hooks/useDesktopDisplay';
import FeedbackCard from '../../common/cards/FeedbackCard';
import { routes } from '../../../assets/routes';
import { useHistory, useParams } from 'react-router-dom';
import { useInfiniteQuery } from '@tanstack/react-query';
import { feedbacksListRequest } from './api';
import Button from '@mui/material/Button';
import { useTranslation } from '../../../i18n/LanguageProvider';

const FeedbackRequestsList = () => {
  const { t, isRtl } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isDesktop = useDesktopDisplay();
  const { userId } = useParams();

  const [tabIndex, setTabIndex] = useState(0);
  const currentUserId = get_user_info()?.id;
  const {
    isLoading: feedbackIsLoading,
    data: feedbackData,
    hasNextPage: feedbackHasNextPage,
    fetchNextPage: feedbackFetchNextPage,
    isFetchingNextPage: feedbackIsFetchingNextPage
  } = useInfiniteQuery(
    ['feedbacksList', userId],
    ({ pageParam = null }) => feedbacksListRequest(pageParam, userId),
    {
      getNextPageParam: (lastPage) => {
        const lastIndex = lastPage.data.length - 1;
        const lastId = lastPage.data[lastIndex]?.id;
        return lastPage.data.length !== 0 ? lastId : undefined;
      },
      select: React.useCallback(
        (data) => data?.pages.flatMap((feedback) => feedback.data),
        []
      ),
      onError(err) {
        toast.error(err.response?.data?.detail);
      }
    }
  );
  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabIndex(index);
  };
  useEffect(() => {
    setHeader(t('conversations.title'));
    setHeaderConfigs({ credits: false, exit: false, back: true, logo: false });
  }, []);

  return (
    <div className={styles.page}>
      <Helmet>
        <title>{t('conversations.title')}</title>
      </Helmet>
      {isDesktop && (
        <div className={styles.pageHeader}>
          <span>{t('conversations.title')}</span>
        </div>
      )}
      <div className={styles.section}>
        <div className={`${styles.sectionTop} ${styles.actionsContainer}`}>
          <Button
            size="small"
            variant="outlined"
            onClick={() => history.push(routes.FEEDBACK_REQUEST_CREATE)}
            className={styles.btn}
          >
            {t('conversations.request')}
          </Button>
          <SimpleTabs value={tabIndex} handleChange={handleChange}>
            <StyledTab label={''} {...a11yProps(0)} />
          </SimpleTabs>
        </div>
        <div className={classNames(styles.sectionBody, styles.noMargin)}>
          <SwipeableViews
            axis={isRtl ? 'x-reverse' : 'x'}
            index={tabIndex}
            onChangeIndex={handleChangeIndex}
            className={styles.swipeArea}
          >
            <TabPanel index={0} value={tabIndex}>
              {feedbackIsLoading ? (
                <Loader size={40} />
              ) : feedbackData.length ? (
                feedbackData.map((feedback, i) => (
                  <FeedbackCard
                    key={i}
                    extraClass={styles.feedbackCard}
                    data={feedback}
                    receiver={feedback.sender.id !== currentUserId}
                    title={feedback.title}
                  />
                ))
              ) : (
                <div className={classNames(styles.emptyCard, styles.feedback)}>
                  {t('conversations.empty')}
                </div>
              )}

              {!feedbackIsLoading &&
                (feedbackIsFetchingNextPage ? (
                  <Loader size={40} />
                ) : feedbackHasNextPage ? (
                  <Button
                    variant="outlined"
                    onClick={feedbackFetchNextPage}
                    fullWidth
                  >
                    {t('common.more')}
                  </Button>
                ) : (
                  <Eof />
                ))}
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </div>
  );
};

export default FeedbackRequestsList;
